<template>
    <footer class="footer">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col items-center justify-between md:flex-row">
            <!-- <a href="/" class="-m-1.5 p-1.5"> -->
            <!-- <img class="h-8 w-auto" src="https://xiaochu.ljwx.site/img/logo2.png"> -->
            <!-- </a> -->
            <p class="mt-6 text-slate-500 md:mt-0 text-sm text-center sm:text-right">
                Copyright © 2025易售SUP云科技. All rights reserved. <br>
            </p>
            <p>
                <a href="https://t.me/yishousup" target="_blank" rel="noopener noreferrer"
                    style="color: #1d78ff;     text-decoration: underline;">TG客服@yishousup</a>
            </p>
        </div>
    </footer>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'IndexFooter'
})
</script>

<style scoped lang="scss">
.footer {
    background-color: white;
    padding: 2.5rem 0;
    width: 100%;
    height: 5vh;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10;
}

.footer img {
    height: 1.5rem;
    width: auto;
}

.footer p {
    font-size: 0.75rem;
    line-height: 1.25rem;
    margin-top: 0.5rem;
}

@media (max-width: 640px) {
    .footer {
        height: fit-content;
        padding: 0.5rem 0;
    }

    .footer p {
        font-size: 0.7rem;
        line-height: 1.2rem;
    }
}

.mx-auto {
    margin-left: auto;
    margin-right: auto;
}

.max-w-7xl {
    max-width: 80rem;
}

.px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
}

.sm\:px-6 {
    @media (min-width: 640px) {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }
}

.lg\:px-8 {
    @media (min-width: 1024px) {
        padding-left: 2rem;
        padding-right: 2rem;
    }
}

.flex {
    display: flex;
}

.flex-col {
    flex-direction: column;
}

.md\:flex-row {
    @media (min-width: 768px) {
        flex-direction: row;
    }
}

.items-center {
    align-items: center;
}

.justify-between {
    justify-content: space-between;
}

.-m-1\.5 {
    margin: -0.375rem;
}

.p-1\.5 {
    padding: 0.375rem;
}

.h-8 {
    height: 2rem;
}

.w-auto {
    width: auto;
}

.mt-6 {
    margin-top: 1.5rem;
}

.text-slate-500 {
    color: #64748b;
}

.md\:mt-0 {
    @media (min-width: 768px) {
        margin-top: 0;
    }
}

.text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
}

.text-center {
    text-align: center;
}

.sm\:text-right {
    @media (min-width: 640px) {
        text-align: right;
    }
}
</style>